import React, { useState, useEffect } from 'react';
import './Notification.css';
import { useSelector, useDispatch } from 'react-redux';
import { setMessage } from 'store/slice/HeaderSlice';

const Notification = ({notification, style}) => {
    const dispatch = useDispatch();
    
    return (
        <>
        {notification.message!== '' && (
            <div
                className={`notification ${notification.visible ? 'show' : 'hide'}`}
                style={style}
            >
                {notification.message}
            </div>
        )}
        </>
    );
};

export default Notification;
